module.exports = __webpack_public_path__ + "img/remark_cn.181b74b2.png";